<div class="table-container">
  <table mat-table [dataSource]="kfRegistration" matSort>

    <ng-container matColumnDef="year">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "kf-reporting.year" | translate }} </th>
      <td mat-cell *matCellDef="let kfRegistration"> {{kfRegistration.year}} </td>
    </ng-container>

    <ng-container matColumnDef="keyFigures">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "country.kf-registration.table.key-figures" | translate }} </th>
      <td mat-cell *matCellDef="let kfRegistration"> {{kfRegistration.keyFigures === 'Recycling' ? 'Recycle %' : kfRegistration.keyFigures}} </td>
    </ng-container>

    <ng-container matColumnDef="b2bb2c">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "country.kf-registration.table.b2b/b2c" | translate }} </th>
      <td mat-cell *matCellDef="let kfRegistration"> {{kfRegistration.keyFigures === 'Recycling' && kfRegistration.status === 'Not started' ? '' : kfRegistration.b2bb2c}} </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "country.kf-registration.table.status" | translate }} </th>
      <td mat-cell *matCellDef="let kfRegistration"> {{kfRegistration.status}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let kfRegistration">
        <mat-icon color="primary" (click)="goToEdit(kfRegistration)">edit</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>

